import { FieldConfig } from "../../../components/form/FieldRenderer";

export const licenseCount: FieldConfig[] = [
  {
    name: "no_of_licenses",
    label: "No. of License",
    type: "text",
    required: true,
  },
];
